import repository from './repsitory'

const resource = '/users'
const token = 'token'
export default {
    get () {
        return repository.get(`${resource}`)
    },
    token (credentials) {
        return repository.post(`${token}`, credentials)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addUser (data) {
        return repository.post(`${resource}`, data)
    },
    updateUser (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
    getRoles () {
        return repository.get(`${resource}/roles`)
    },
}
